export const en_US_translations_fallback = {
  log_in: 'Log In',
  work_email: 'Work email',
  log_into_your_account_below: 'Log into your account below',
  form_fill: 'Password',
  form_fill_subtext: 'Required',
  forgot_password: 'Forgot Password',
  forgot_password_flow_subtext:
    'To be emailed a link to reset your password, please enter your email address.',
  button_label: 'Send code',
  reset_password: 'Reset Password',
  code: 'Code',
  reset_password_flow_password: 'Password',
  reset_password_flow_password_copy_subtext:
    'Must be at least 8 characters, including a number and a symbol.',
  change_password_button_label: 'Change Password',
  reset_password_flow_page_2:
    'Your password has been successfully reset. Please log in.',
  sign_in_button_label: 'Sign In',
  sign_in_button_label_copy_subtext: 'Forgot Password?',

  unlock_copy: 'Unlock your full potential with Thrive',
  thrive_app_members_copy:
    'The Thrive app is a behavior change coach in your pocket that will help you manage stress, improve focus, strengthen connections with others (even from afar), and improve overall well-being.',
  otherWays: 'Other ways to get the Thrive Global App',
  navigation_bar: 'Sign Out',
  page_welcome_copy: 'Welcome to Thrive!',
  page_download_app: 'Download the Thrive App',
  page_download_app_copy:
    'The Thrive App is the world’s first behavior change platform combining data, stories, and actionable Microsteps to help your people create sustainable healthy habits and improve performance. Your login and password will work for the app!',
  page_thrive_academy: 'Thrive Academy',
  page_thrive_academy_copy:
    'Thrive brings you interactive learning experiences delivered by the world’s leading experts – with our signature Microsteps to move from awareness to action.',
  page_thrive_academy_link: 'Go now >',

  sign_up_page_1_title: 'Sign Up',
  sign_up_page_1_text:
    "To access Thrive, sign up and enter your company's Group Code. If you're not sure what is your Group Code, please contact us.",
  sign_up_page_1_text_2:
    "To access Thrive, sign up and enter your company's Group Code. If you're not sure what is your Group Code, please <0>contact us</0>.",
  sign_up_page_1_link: 'contact us.',
  sign_up_page_1_button_label: 'Sign Up',
  sign_up_page_2_title: 'Sign Up',
  sign_up_page_2_copy:
    "To access Thrive, sign up and enter your company's Group Code. If you're not sure what is your Group Code, please contact us.",
    sign_up_page_2_group_code_copy_subtext:
    "Where do I get my group code? Email <0>{{email}}</0> to get your group code.",
  form_fill_first_name: 'First name',
  form_fill_last_name_copy: 'Last name',
  form_fill_password: 'Password',
  form_fill_group_code: 'Group code',
  form_fill_email: 'Email',
  form_fill_job_title: 'Job Title',
  form_fill_company_size: 'Employees',
  form_fill_company: 'Company',
  sign_up_button: '',
  sign_up_footer_text: 'Having trouble? Contact: ',
  sign_up_footer_text_email: 'productfeedback@thriveglobal.com',
  sign_up_page_2_link: 'contact us',
  sign_up_button_subtext_copy: 'Already have an account?',
  sign_up_button_subtext_label: 'Log in',
  sign_up_footer_link_copy1: 'Privacy Policy',
  sign_up_footer_link_copy2: 'Terms and Conditions',
  contactus: 'Contact us',

  navigation_bar_help: 'Help',
  navigation_bar_login: 'Login',
  main_page_copy:
    'Welcome to this unique site dedicated to Thrive Global’s human experience programs. You will benefit from the latest scientific advances, inspiring stories and micro-steps to help you unleash your potential and create a life of well-being and enhanced performance.',
  main_page_byline: 'Thrive through our learning experiences:',
  main_page_title_1: 'Back to school solutions',
  main_page_title_2: 'Thrive Academy',
  main_page_title_3: 'Flourish together',
  main_page_title_4: 'Thrive through our differences',
  main_page_title_5: 'Great Parenting',
  main_page_title_6: 'Thrive at Work',
  main_page_title_7: 'A healthy mind',
  main_page_title_8: 'Thrive in the New Normal',
  main_page_title_9: 'A fulfilling performance',
  main_page_title_10: 'Active Families',
  main_page_title_11: 'Chinese Wisdom',
  main_page_description_1:
    'Take on the challenges of back to school and take care of your family without sacrificing well-being.',
  main_page_description_2:
    'This six-week online course with Arianna Huffington helps you move from survival to thriving. The course uses scientifically proven methods to reduce stress and burnout.',
  main_page_description_3:
    'Strengthening individual and collective resilience and creating experiences of belonging.',
  main_page_description_4:
    'Create inclusive environments where everyone can thrive.',
  main_page_description_5:
    'Travel the path to parenting with less stress and more fun.',
  main_page_description_6:
    'Understand the science-backed connection between well-being and performance.',
  main_page_description_7:
    'Put your mental well-being first with the most advanced brain science.',
  main_page_description_8:
    'Continue to thrive throughout the coronavirus pandemic by adopting healthy habits of prevention and productivity.',
  main_page_description_9:
    'Unlock your best, most fulfilled and most productive self.',
  main_page_description_10:
    'Create a more equitable and inclusive culture that empowers individuals, teams and organizations to perform well.',
  main_page_description_11:
    'Apply ancient Chinese wisdom and philosophy to your own life.',
  newsletter_sign_up_title: "Arianna's Weekly Thoughts",
  newsletter_sign_up_byline:
    "A Sunday newsletter featuring Arianna's take on the news of the week, her favorite articles on how we can thrive even in our stressful world, and some fun and inspiring extras.",
  landing_page_email_form: 'Enter your email address',
  landing_page_email_button: 'Subscribe',
  footer_copy:
    '"People seek retreats for themselves, in the country, on the coast or in the hills ... Nowhere else can a person find a more peaceful and trouble-free retreat than in his own mind ... So, give yourself this retreat regularly, and renew yourself. "',
  footer_legal:
    'About Us, Contact Us, Leadership, Company, Media Partnerships, Career, Press, Privacy Terms',

  cta_title: 'Get Thrive Academy For Your Company',
  cta_byline: 'Navigate this time with less stress and greater resilience.',
  cta_button_label: 'Request a Demo',
  cta_request_demo_success: 'Demo Request Submitted',
  cta_request_demo_error: 'Demo Request Failed',

  cta_get_app_title: 'Get Thrive Academy on the Thrive App',
  cta_get_app_byline:
    'Download the Thrive app today to access the Learn Curriculum, and powerful tools to hold yourself accountable with Microsteps and keep yourself on your chosen Journey. Point your camera at the QR code below!',

  top_splash_title: 'Thrive with Our Academy Learning Experiences',
  top_splash_byline:
    "Welcome to your one-stop shop for Thrive Global's people experience programs. You'll get the latest science, inspirational storytelling, and actionable Microsteps to help you unlock your potential and build a life of improved well-being and performance.",
  top_splash_cta_text: 'Request a Demo',
  top_splash_blurb:
    'Each self-directed learning program features snackable videos, expert advice, inspiring role models, and Microsteps that are too small to fail. Whatever your goals and circumstances, you’ll find inspiration to take action',
  email_address_invalid: 'Not a valid email address.',
  password_min_length: 'Password must be at least 8 characters.',
  password_no_match_requirements: 'Password does not match below requirements.',
  password_six_numbers: 'Must be exactly 6 numbers.',
  required: 'Required.',
  passwordSixNumbers: 'Must be exactly 6 numbers.',

  // New Thrive Web

  // Login Modal
  login_modal_button: 'Next',
  login_modal_title: 'Log into Thrive Academy',
  login_modal_sub_title: 'Enter your work email to get started',
  login_modal_action_link: 'Request a Demo',
  login_modal_placeholder: 'Work Email',
  login_modal_user_does_not_exist:
    'This user account does not exist. Please check and try again.',
  login_modal_email_us: 'Email Us',
  login_modal_email_us_postfix: 'for further support.',

  // Home Page
  thrive_home_splash_title: 'Thrive With Our Academy Learning Experiences',
  thrive_home_splash_action: 'Request a Demo',
  thrive_home_splash_copy:
    "Welcome to your one-stop shop for Thrive Global's people experience programs. You'll get the latest science, inspirational storytelling, and actionable Microsteps to help you unlock your potential and build a life of improved well-being and performance.",
  thrive_home_splash_body: `Each self-directed learning program features snackable videos expert advice, inspiring role models, and Microsteps that are too small to fail. Whatever your goals and circumstances, you’ll find inspiration to take action.`,

  thrive_home_icon_bar_microstep_title: 'Microsteps',
  thrive_home_icon_bar_microstep_copy:
    'Small, science-backed steps you can start taking immediately to build habits that significantly improve your life.',
  thrive_home_icon_bar_guide_title: 'Guides',
  thrive_home_icon_bar_guide_copy:
    'Get the latest science, inspirational storytelling, and actionable Microsteps on the topics that matter most to you.',
  thrive_home_icon_bar_assessment_title: 'Assessments',
  thrive_home_icon_bar_assessment_copy:
    "Answer simple questions about yourself to get insights on where you're thriving — and where you're not.",

  login_modal_title_password: 'Welcome Back',
  login_modal_sub_title_password: 'Enter your password',
  login_modal_placeholder_password: 'Password',
  login_modal_button_password: 'Log In',
  login_modal_forgotten_password: 'Forgot your password?',
  login_modal_incorrect_password: 'Incorrect password. Please try again.',

  login_modal_title_reset_password: 'Forgot Password',
  login_modal_sub_title_reset_password:
    'Click the button below to send an email to reset your password. Copy the verification code below to reset the password',
  login_modal_button_reset_password: 'Send Email',
  login_modal_button_change_password: 'Update password',
  login_modal_back_to_login: 'Back to Login',

  login_modal_reset_password_verification_code: 'Verification Code',
  login_modal_reset_password_new: 'New Password',

  completed: 'Completed',

  read_mode: 'Read More',

  // Articles
  article_min_read: 'min read',

  // Statuses
  status_locked: 'Locked',
  status_saved_microstep: 'Saved Microstep',
  status_schedule_reminder: 'Schedule a reminder',
  status_downloaded: 'Downloaded',

  // Guides
  guide_pages: 'Pages',
  guide_count: '{{ count }} Guides',

  // Microsteps
  microstep_count: '{{ count }} Microsteps',

  // Assessments
  assessment_count: '{{ count }} Assessments',

  // Quiz
  quiz_questions: '{{ count }} Questions',
  quiz_see_results: 'See Results',
  quiz_get_started: 'Get Started',

  // Article
  article_count: '{{ count }} Articles',

  // Lesson
  lesson_about: 'About this lesson:',

  // Course
  course: 'Course',
  course_about: 'About this Course',
  course_lesson: 'Lesson',
  course_no_lessons: 'There are no lessons',
  course_view_entire: 'View entire course',
  lesson_includes: 'Lesson Includes',
  course_includes: 'Course Includes',
  course_playlist: 'The Course Playlist',
  course_what_you_learn: 'What you’ll learn',
  course_meet_experts: 'Meet the experts',
  course_playlist_description:
    'This course includes {{ count }} lessons. Start from the beginning, or skip right to a section that resonates with you!',
  course_includes_microsteps: '{{ count }} Microsteps',
  course_includes_assessments: '{{ count }} Assessments',
  course_includes_guides: '{{ count }} Guides',
  course_includes_videos: '{{ count }} Videos',
  course_includes_articles: '{{ count }} Articles',
  course_includes_total_time: '{{ time }} total time',

  resources_title: 'Resources included in this course',
  resources_byline:
    'This course includes {{ lessons }} lessons and {{ modules }} individual modules. You have completed {{ completePercentage }} of this course..',

  // Tabs
  tab_overview: 'Overview',
  tab_this_lesson: 'This Lesson',
  tab_course_playlist: 'Course Playlist',
  tab_all_resourses: 'All Resources',
}
